var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/status_content.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import classNames from 'classnames';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Icon from 'soapbox/components/icon';
import { useSoapboxConfig } from 'soapbox/hooks';
import { MentionRecord } from 'soapbox/normalizers';
import { addGreentext } from 'soapbox/utils/greentext';
import { onlyEmoji as isOnlyEmoji } from 'soapbox/utils/rich_content';
import { isRtl } from '../rtl';
import Poll from './polls/poll';
import { Button, Text } from './ui';
const MAX_HEIGHT = 642; // 20px * 32 (+ 2px padding at the top)
const BIG_EMOJI_LIMIT = 10;
/** Button to expand a truncated status (due to too much content) */
const ReadMoreButton = ({
  onClick
}) => /*#__PURE__*/React.createElement(Button, {
  onClick: onClick,
  theme: "link",
  size: "sm",
  classNames: "-mx-3",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 30,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "status.read_more",
  defaultMessage: "Read more",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 31,
    columnNumber: 5
  }
}), /*#__PURE__*/React.createElement(Icon, {
  className: "inline-block h-5 w-5",
  src: require('@tabler/icons/chevron-right.svg'),
  fixedWidth: true,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 32,
    columnNumber: 5
  }
}));
/** Button to expand status text behind a content warning */
const SpoilerButton = ({
  onClick,
  hidden,
  tabIndex
}) => /*#__PURE__*/React.createElement(Button, {
  theme: "ghost",
  size: "sm",
  onClick: onClick,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 45,
    columnNumber: 3
  }
}, hidden ? /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "status.show_more",
  defaultMessage: "Show more",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 51,
    columnNumber: 7
  }
}) : /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "status.show_less",
  defaultMessage: "Show less",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 53,
    columnNumber: 7
  }
}));
const Spoiler = ({
  hidden,
  onClick,
  status
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between bg-gray-100 dark:bg-slate-700 p-2 rounded mt-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 5
    }
  }, status.spoiler_text.length > 0 ? /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "status.cw",
    defaultMessage: "Warning:",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 15
    }
  })), "\xA0", /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: status.spoilerHtml
    },
    lang: status.language || undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "status.filtered",
    defaultMessage: "Filtered",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement("br", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "xs",
    theme: "muted",
    tag: "span",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "status.filtered-hint",
    defaultMessage: "Status was hidden by filter settings",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 7
    }
  }, status.media_attachments?.count() > 0 && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    className: "flex gap-1 items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "inline-block",
    src: require('@tabler/icons/paperclip.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "xs",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 15
    }
  }, status.media_attachments.count())), /*#__PURE__*/React.createElement(SpoilerButton, {
    tabIndex: 0,
    onClick: onClick,
    hidden: hidden,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 9
    }
  })));
};
/** Renders the text content of a status */
const StatusContent = ({
  status,
  expanded = false,
  onExpandedToggle,
  onClick,
  collapsable = false
}) => {
  const history = useHistory();
  const [hidden, setHidden] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [onlyEmoji, setOnlyEmoji] = useState(false);
  const node = useRef(null);
  const {
    greentext
  } = useSoapboxConfig();
  const onMentionClick = (mention, e) => {
    if (e.button === 0 && !(e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      e.stopPropagation();
      history.push(`/@${mention.acct}`);
    }
  };
  const onHashtagClick = (hashtag, e) => {
    hashtag = hashtag.replace(/^#/, '').toLowerCase();
    if (e.button === 0 && !(e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      e.stopPropagation();
      history.push(`/tag/${hashtag}`);
    }
  };

  /** For regular links, just stop propogation */
  const onLinkClick = e => {
    e.stopPropagation();
  };
  const updateStatusLinks = () => {
    if (!node.current) return;
    const links = node.current.querySelectorAll('a');
    links.forEach(link => {
      // Skip already processed
      if (link.classList.contains('status-link')) return;

      // Add attributes
      link.classList.add('status-link');
      link.setAttribute('rel', 'nofollow noopener');
      link.setAttribute('target', '_blank');

      // some clients seem to publish mention without adding them to the mentions array
      // but by adding a data-user attr, so we try to build something here
      let undetectedMention = null;
      if (link.getAttribute('data-user')) {
        const matchs = link.href.match(/https:\/\/([^/]+)\/@([^/]+)/);
        if (matchs && matchs.length >= 3) {
          undetectedMention = MentionRecord({
            id: link.getAttribute('data-user'),
            url: link.href,
            acct: `${matchs[2]}@${matchs[1]}`
          });
        }
      }
      const mention = status.mentions.find(mention => link.href === `${mention.url}`) || undetectedMention;

      // Add event listeners on mentions and hashtags
      if (mention) {
        link.addEventListener('click', onMentionClick.bind(link, mention), false);
        link.setAttribute('title', mention.acct);
      } else if (link.textContent?.charAt(0) === '#' || link.previousSibling?.textContent?.charAt(link.previousSibling.textContent.length - 1) === '#') {
        link.addEventListener('click', onHashtagClick.bind(link, link.text), false);
      } else {
        link.setAttribute('title', link.href);
        link.addEventListener('click', onLinkClick.bind(link), false);
      }
    });
  };
  const maybeSetCollapsed = () => {
    if (!node.current) return;
    if (collapsable && onClick && !collapsed && status.spoiler_text.length === 0) {
      if (node.current.clientHeight > MAX_HEIGHT) {
        setCollapsed(true);
      }
    }
  };
  const maybeSetOnlyEmoji = () => {
    if (!node.current) return;
    const only = isOnlyEmoji(node.current, BIG_EMOJI_LIMIT, true);
    if (only !== onlyEmoji) {
      setOnlyEmoji(only);
    }
  };
  useEffect(() => {
    maybeSetCollapsed();
    maybeSetOnlyEmoji();
    updateStatusLinks();
  });
  const handleSpoilerClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onExpandedToggle) {
      // The parent manages the state
      onExpandedToggle();
    } else {
      setHidden(!hidden);
    }
  };
  const parsedHtml = useMemo(() => {
    const {
      contentHtml: html
    } = status;
    if (greentext) {
      return addGreentext(html);
    } else {
      return html;
    }
  }, [status.contentHtml]);
  if (status.content.length === 0) {
    return null;
  }
  const isHidden = onExpandedToggle ? !expanded : hidden;
  const content = {
    __html: parsedHtml
  };
  const directionStyle = {
    direction: 'ltr'
  };
  const className = classNames('status__content', {
    'status__content--with-action': onClick,
    'status__content--with-spoiler': status.spoiler_text.length > 0,
    'status__content--collapsed': collapsed,
    'status__content--big': onlyEmoji
  });
  if (isRtl(status.search_index)) {
    directionStyle.direction = 'rtl';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${className} flex flex-col gap-2`,
    ref: node,
    tabIndex: 0,
    style: directionStyle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 274,
      columnNumber: 7
    }
  },
  // post has a spoiler or was filtered
  (status.spoiler_text.length > 0 || status.filtered) && /*#__PURE__*/React.createElement(Spoiler, {
    status: status,
    hidden: isHidden,
    onClick: handleSpoilerClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 278,
      columnNumber: 13
    }
  }),
  // actual content
  !isHidden && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    tabIndex: !isHidden ? 0 : undefined,
    className: classNames('min-h-0 overflow-hidden text-ellipsis status__content__text status__content__text--visible'),
    style: directionStyle,
    dangerouslySetInnerHTML: content,
    lang: status.language || undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 289,
      columnNumber: 15
    }
  }),
  // post folded because too long
  collapsed && onClick && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 299,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(ReadMoreButton, {
    onClick: onClick,
    key: "read-more",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 300,
      columnNumber: 21
    }
  })),
  // post has a poll
  !collapsed && status.poll && typeof status.poll === 'string' && /*#__PURE__*/React.createElement(Poll, {
    id: status.poll,
    key: "poll",
    status: status.url,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 307,
      columnNumber: 19
    }
  }))));
};
export default /*#__PURE__*/React.memo(StatusContent);